import { Element, Transforms } from "slate";
import { insertLink, wrapInLink } from "./link-utilities";
export const withLinks = (editor) => {
    const { isInline, insertData, normalizeNode } = editor;
    editor.isInline = (element) => (element.type === "link" ? true : isInline(element));
    editor.insertData = (data) => {
        // Paste link support
        const text = data.getData("text/plain");
        const isUrl = text.match(/^(https|http):\/\/\S*$/);
        return isUrl ? insertLink({ editor, href: text, text }) : insertData(data);
    };
    editor.normalizeNode = (entry) => {
        const [node, path] = entry;
        // Backwards compatibility for when the image type supported href and target
        if (Element.isElement(node) && node.type === "image" && node.href) {
            const { target, href } = node;
            Transforms.setNodes(editor, { href: undefined, target: undefined }, { at: path });
            wrapInLink({ editor, path, href, openInNewTab: target === "_blank" });
            return;
        }
        // Fall back to the original `normalizeNode` to enforce other constraints.
        normalizeNode(entry);
    };
    return editor;
};
